import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * Floating scroll-down cue shown on every page. Fades out once the user
 * starts scrolling; clicking glides one viewport down (Lenis-aware).
 */
export default function ScrollDownArrow() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const onScroll = () => setHidden(window.scrollY > 120);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    const target = window.scrollY + window.innerHeight * 0.9;
    if (window.__lenis) window.__lenis.scrollTo(target);
    else window.scrollTo({ top: target, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.button
          type="button"
          onClick={handleClick}
          data-testid="scroll-down-arrow"
          aria-label="Scroll down"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ duration: 0.6, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 z-40 w-11 h-11 rounded-full border border-[color:var(--collab-hairline)] bg-[rgba(245,241,232,0.85)] backdrop-blur-md shadow-[0_2px_12px_rgba(0,0,0,0.08)] flex items-center justify-center hover:bg-[color:var(--collab-cream)] transition-colors"
        >
          <motion.svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden
            animate={{ y: [0, 3.5, 0] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
          >
            <path
              d="M3 6l5 5 5-5"
              stroke="var(--collab-ink)"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </motion.svg>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
